import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useFundUtilisation() {
  return useQuery({
    queryKey: ['reporting', 'fund-utilisation'],
    queryFn: async () => {
      const { data } = await api.get('/reports/fund-utilisation');
      return data;
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}

export function usePipelineByStage() {
  return useQuery({
    queryKey: ['reporting', 'pipeline'],
    queryFn: async () => {
      const { data } = await api.get('/reports/pipeline');
      return data;
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}

export function useUpcomingMaturities(days?: number) {
  return useQuery({
    queryKey: ['reporting', 'upcoming-maturities', days],
    queryFn: async () => {
      const { data } = await api.get('/reports/upcoming-maturities', {
        params: days ? { days } : {},
      });
      return data;
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}

export function useArrearsAging() {
  return useQuery({
    queryKey: ['reporting', 'arrears-aging'],
    queryFn: async () => {
      const { data } = await api.get('/reports/arrears-aging');
      return data;
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}

export function useFeeIncomePL(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['reporting', 'fee-income-pl', startDate, endDate],
    queryFn: async () => {
      const { data } = await api.get('/reports/fee-income-pl', {
        params: startDate || endDate ? { startDate, endDate } : {},
      });
      return data;
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}

export function useDiaryOverdue() {
  return useQuery({
    queryKey: ['reporting', 'diary-overdue'],
    queryFn: async () => {
      const { data } = await api.get('/reports/diary-overdue');
      return data;
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}
